import {
  AgencySubscriptionFieldsFragment,
  SubscriptionPeriod,
  SubscriptionPlan
} from '~/api/graphql';
import { parseSubscriptionDate } from './renewal-billing-date';

export const RENEWAL_BANNER_SHELL =
  'overflow-hidden rounded-lg bg-gradient-to-r from-sky-700 to-sky-600';
export const RENEWAL_BANNER_INNER = 'px-4 py-5 sm:p-6';

export const RENEWAL_CALL_URL = 'https://meetings.hubspot.com/shiv-cara/renewal-plan';
export const STANDARD_PLAN_TERMS_URL = 'https://www.getcara.ai/terms';

export const RENEWAL_PLAN_OPTIONS = [
  {
    id: SubscriptionPlan.Pro,
    name: 'Cara Pro',
    description: 'A plan that scales with your rapidly growing business.'
  },
  {
    id: SubscriptionPlan.Basic,
    name: 'Cara Basic',
    description: 'The essentials to provide your best work for clients.'
  }
] as const;

export const ANNUAL_RENEWAL_PLAN_LABELS: Partial<Record<SubscriptionPlan, string>> =
  Object.fromEntries(RENEWAL_PLAN_OPTIONS.map((option) => [option.id, option.name]));

type AnnualRenewalSubscription = Pick<
  AgencySubscriptionFieldsFragment,
  'plan' | 'annualRenewalDate'
>;

/** The renewal date as a local calendar date, so it displays as the same day everywhere. */
export const getAnnualRenewalDate = (
  subscription?: AnnualRenewalSubscription | null
): Date | null =>
  subscription?.annualRenewalDate
    ? parseSubscriptionDate(String(subscription.annualRenewalDate))
    : null;

export const formatAnnualRenewalDate = (date: Date): string =>
  date.toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' });

export const formatBillingPeriod = (period?: SubscriptionPeriod | null): string =>
  period === SubscriptionPeriod.Annual ? 'per year' : 'per month';
